import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker';
import App from "./App";

window.Buffer = Buffer;

const hideInitialSplash = () => {
	if (typeof window.hideSplashScreen === "function") {
		window.hideSplashScreen();
	}
};

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	hideInitialSplash
);

serviceworker.register();
